import { render, staticRenderFns } from "./RegisterSuccessView.vue?vue&type=template&id=1031dab3&scoped=true&"
import script from "./RegisterSuccessView.vue?vue&type=script&lang=js&"
export * from "./RegisterSuccessView.vue?vue&type=script&lang=js&"
import style0 from "./RegisterSuccessView.vue?vue&type=style&index=0&id=1031dab3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1031dab3",
  null
  
)

export default component.exports